import { TransformedLocaleConfig, LocaleName } from '../type';
const baseLocaleConfig = {
  name: 'ceb',
  months: [
    'Enero',
    'Pebrero',
    'Marso',
    'Abril',
    'Mayo',
    'Hunyo',
    'Hulyo',
    'Agosto',
    'Septyembre',
    'Oktubre',
    'Nobyembre',
    'Disyembre',
  ],
  monthsShort: ['Ene', 'Peb', 'Mar', 'Abr', 'Mayo', 'Hun', 'Hul', 'Ago', 'Sep', 'Okt', 'Nob', 'Dis'],
  weekdays: ['Domingo', 'Lunes', 'Martes', 'Miyerkules', 'Huwebes', 'Biyernes', 'Sabado'],
  weekdaysMin: ['D', 'L', 'M', 'M', 'H', 'B', 'S'],
  weekdaysShort: ['Dom', 'Lun', 'Mar', 'Mer', 'Huw', 'Biy', 'Sab'],
  formats: {
    LT: 'HH:mm',
    LTS: 'HH:mm:ss',
    lt: 'h:mm A',
    lts: 'h:mm:ss A',
    L: 'MM/DD/YYYY',
    LL: 'MMMM D, YYYY',
    'LL-D': 'MMMM YYYY',
    'LL-Y': 'MMMM D',
    LLL: 'MMMM D, YYYY, HH:mm',
    'LLL-Y': 'MMMM D, HH:mm',
    LLLL: 'dddd, MMMM D, YYYY, HH:mm',
    'LLLL-Y': 'dddd MMMM D, HH:mm',
    l: 'M/D/YYYY',
    'l-Y': 'M/D',
    ll: 'MMM D, YYYY',
    'll-Y': 'MMM D',
    'll-D': 'MMM YYYY',
    lll: 'MMM D, YYYY, h:mm A',
    'lll-Y': 'MMM D, h:mm A',
    llll: 'ddd, MMM D, YYYY, h:mm A',
    'llll-Y': 'ddd, MMM D, h:mm A',
    'll-Y+w': 'ddd, MMM D',
    'LT+to': 'HH:mm ([GMT]Z)',
    'LLL+to': 'MMMM D, YYYY, HH:mm ([GMT]Z)',
  },
  meridiem: { am: 'am', pm: 'pm', AM: 'AM', PM: 'PM' },
  past: {
    y: { other: '%sy ang milabay' },
    M: { other: '%smo ang milabay' },
    w: { other: '%sw ang milabay' },
    d: { other: '%sa ang milabay' },
    h: { other: '%so ang milabay' },
    m: { other: '%sm ang milabay' },
    s: { other: '%ss ang milabay' },
  },
  future: {
    y: { other: 'sa %sy' },
    M: { other: 'sa %smo' },
    w: { other: 'sa %sw' },
    d: { other: 'sa %sa' },
    h: { other: 'sa %so' },
    m: { other: 'sa %sm' },
    s: { other: 'sa %ss' },
  },
  pastLong: {
    y: { other: '%s ka tuig ang milabay' },
    M: { other: '%s ka bulan ang milabay' },
    w: { other: '%s ka semana ang milabay' },
    d: { other: '%s ka adlaw ang milabay' },
    h: { other: '%s ka oras ang milabay' },
    m: { other: '%s ka minuto ang milabay' },
    s: { other: '%s ka segundo ang milabay' },
  },
  futureLong: {
    y: { other: 'sa %s ka tuig' },
    M: { other: 'sa %s ka bulan' },
    w: { other: 'sa %s ka semana' },
    d: { other: 'sa %s ka adlaw' },
    h: { other: 'sa %s ka oras' },
    m: { other: 'sa %s ka minuto' },
    s: { other: 'sa %s ka segundo' },
  },
  abbr: {
    y: { one: '%sy', other: '%sy' },
    M: { one: '%smo', other: '%smo' },
    w: { one: '%sw', other: '%sw' },
    d: { one: '%sa', other: '%sa' },
    h: { one: '%so', other: '%so' },
    m: { one: '%sm', other: '%sm' },
    s: { one: '%ss', other: '%ss' },
  },
  full: {
    y: { one: '%s ka tuig', other: '%s ka mga tuig' },
    M: { one: '%s ka buwan', other: '%s ka mga buwan' },
    w: { one: '%s ka semana', other: '%s ka mga semana' },
    d: { one: '%s ka adlaw', other: '%s ka mga adlaw' },
    h: { one: '%s ka oras', other: '%s ka mga oras' },
    m: { one: '%s ka minuto', other: '%s ka mga minuto' },
    s: { one: '%s ka segundo', other: '%s ka mga segundo' },
  },
  justNow: 'Bag-o lang',
  yesterday: 'Gahapon',
  today: 'Karong adlawa',
  tomorrow: 'Ugma',
  weekStart: 0,
  timeRange: '%$1s – %$2s',
  timeZone: '%$1s %$2s',
  timePref: { 'HH:mm': 'h:mm A' },
  timeRangeStyles: {
    yl: { start: 'MMMM D, YYYY', end: 'MMMM D, YYYY' },
    'yl-1': { start: 'MMMM D', end: 'MMMM D, YYYY' },
    ml: { start: 'MMMM D', end: 'MMMM D' },
    'ml-1': { start: 'MMMM D', end: 'D, YYYY' },
    dl: { start: 'MMMM D', end: 'D' },
    y: { start: 'MMM D, YYYY', end: 'MMM D, YYYY' },
    'y-1': { start: 'MMM D', end: 'MMM D, YYYY' },
    m: { start: 'MMM D', end: 'MMM D' },
    'm-1': { start: 'MMM D', end: 'D, YYYY' },
    d: { start: 'MMM D', end: 'D' },
    Y: { start: 'ddd, MMM D, YYYY', end: 'ddd, MMM D, YYYY' },
    'Y-1': { start: 'ddd, MMM D', end: 'ddd, MMM D, YYYY' },
    M: { start: 'ddd, MMM D', end: 'ddd, MMM D' },
    D: { start: 'ddd, MMM D', end: 'ddd, MMM D' },
    yt: { start: 'MMM D, YYYY, HH:mm', end: 'MMM D, YYYY, HH:mm' },
    mt: { start: 'MMM D, HH:mm', end: 'MMM D, HH:mm' },
    dt: { start: 'MMM D, HH:mm', end: 'MMM D, HH:mm' },
    t: { start: 'HH:mm', end: 'HH:mm' },
    'yt+to': { start: 'MMM D, YYYY, HH:mm', end: 'MMM D, YYYY, HH:mm ([GMT]Z)' },
    'mt+to': { start: 'MMM D, HH:mm', end: 'MMM D, HH:mm ([GMT]Z)' },
    'dt+to': { start: 'MMM D, HH:mm', end: 'MMM D, HH:mm ([GMT]Z)' },
    't+to': { start: 'HH:mm', end: 'HH:mm ([GMT]Z)' },
  },
};
const localeName: LocaleName = 'ceb';
export const localeConfig: TransformedLocaleConfig = {
  ...baseLocaleConfig,
  name: localeName,
  ordinal: (n) => `${n}`,
  meridiem: (hour, _, isLowerCase = false): string => {
    if (hour < 12) {
      return isLowerCase ? 'am' : 'AM';
    } else {
      return isLowerCase ? 'pm' : 'PM';
    }
  },
};
